import { IAppState } from '../../../../shared/common/state';

export const selectIsVillageMortgageFilterEnabled = (state: IAppState): boolean => {
  return state.filters.isVillageMortgageFilterEnabled;
};
